
export const text = `

Hey, girl. What's wrong? That nightmare again?

[ANXIOUS FLUTTERING.]

Oh… I'm sorry. I'm-- it's alright. I'm here, okay? Be-- be careful with the coat! I don't know if you'd want to talk about it, I-- I mean, you can't, but, but, uh, I guess if you can't… I could ramble if it'd make you feel better?

That's okay? Yeah, alright. What to talk about…

`